import { isMobileScreen } from './mediaQuery'

export type ElementIsOnScreenType = (
    selector: string,
    callback: (element: NodeListOf<HTMLElement>) => void
) => void
const elementIsOnScreen: ElementIsOnScreenType = (selector, callback) => {
    let element: NodeListOf<HTMLElement> | null = null
    const interval = setInterval(() => {
        element = document.querySelectorAll<HTMLElement>(selector)
        if (element.length) {
            clearInterval(interval)
            callback(element)
        }
    }, 100)
}

const subMenuAction = (classList: DOMTokenList): HTMLElement => {
    const [subMenuClass] = [...classList].filter((el) => el.includes('js'))
    const [subMenuToShowMobile, subMenuToShowDesktop] = [
        ...document.querySelectorAll<HTMLElement>(`.${subMenuClass}`)
    ].filter((el) => el.classList.contains('menu-cms-side-content'))

    if (isMobileScreen()) {
        return subMenuToShowMobile
    }

    return subMenuToShowDesktop
}

export { elementIsOnScreen, subMenuAction }
